import React, { Fragment } from 'react';
import { classNamesPrefixed } from "../../../helpers/CoreHelpers";
import Collapsible from "react-collapsible";
import { collapsibleSettings } from "../../helpers/Helpers";
import ImageField from "./ImageField";
import InputWrap from "./InputWrap";
import WYSIWYGField from './WYSIWYGField';
import SelectField from './SelectField';
import CONSTANTS from '../../config/constants';

const NewsArticleContentField = (props) => {
    const { input, label, omitCollapsible, expanded } = props;

    const onChangeImage = (image) => {
        input.onChange({
            ...input.value,
            image
        });
    };

    const onChangeOpacity = (opacity) => {
        input.onChange({
            ...input.value,
            opacity
        });
    };

    const onChangePreamble = (preamble) => {
        input.onChange({
            ...input.value,
            preamble
        });
    };

    const onChangeBody = (body) => {
        input.onChange({
            ...input.value,
            body
        });
    };

    const defaultValue = 100;
    const content = (
        <InputWrap {...props} label={null}>
            <ImageField
                {...props}
                title={'Image'}
                input={{
                    value: input.value.image ? input.value.image : '',
                    onChange: onChangeImage
                }}
                omitCollapsible={true}
            />
            <br />
            <SelectField
                label={'Opacity'}
                defaultValue={input.value.opacity ? CONSTANTS.OPACITY_DROPDOWN.find((a) => a.id === input.value.opacity) : CONSTANTS.OPACITY_DROPDOWN.find((a) => a.id === defaultValue)}
                omitCollapsible={true}
                afterOnChange={(opacity) => {
                    onChangeOpacity(opacity);
                }}
                items={CONSTANTS.OPACITY_DROPDOWN}
                classes="field--opacity"
            />
            <br />
            <br />
            <WYSIWYGField
                {...props}
                label={'Preamble'}
                input={{
                    value: input.value.preamble || '',
                    onChange: onChangePreamble
                }}
                omitCollapsible={true}
            />
            <br />
            <br />
            <WYSIWYGField
                {...props}
                label={'Body'}
                input={{
                    value: input.value.body || '',
                    onChange: onChangeBody
                }}
                omitCollapsible={true}
            />
        </InputWrap>
    );

    return (
        <Fragment>
            {omitCollapsible ? (
                <div>{content}</div>
            ) : (
                    <Collapsible
                        {...collapsibleSettings}
                        trigger={<label className={classNamesPrefixed({ "trigger__label": true })}>{label ? label : 'Image'}</label>}
                        open={expanded}
                    >
                        {content}
                    </Collapsible>
                )}
        </Fragment>
    );
};

export default NewsArticleContentField;


// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/NewsArticleContentField.js